import { LogLevel } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'YOUR_AZURE_TENANT_ID'}`, // use the tenant, not "common", for API Gateway JWT authorizer
    redirectUri: "/redirect",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,   // Set to TRUE only if necessary for IE11 support
    secureCookies: true              // Ensure this is enabled if using cookies },
  },
  system: { loggerOptions: { logLevel: LogLevel.Error } },
};

// API-specific scopes for your custom API (NOT Microsoft Graph)
export const apiScopes = [`api://${import.meta.env.VITE_API_CLIENT_ID || import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`];

// API base URL
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "https://your-api-gw-id.execute-api.region.amazonaws.com";

// Legacy exports for backward compatibility
export const loginRequest = {
  scopes: apiScopes,
};